import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import queryString from "app/services/queryStringService";
import _ from "lodash";
import { AiFillFileExcel } from "react-icons/ai";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import moment from "moment";

import { getTransactionLogAll, exportLedger } from "app/services/SearchService";
import HandyScroll from "app/common/Scroll";
import Tooltip from "rc-tooltip";

const TransactionHistory = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [TransactionMode, setTransactionMode] = useState("");

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "FromDate":
        setFromDate(value);

        break;
      case "ToDate":
        setToDate(value);
        break;
      // Add cases for other fields...
      case "TransactionMode":
        setTransactionMode(value);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    loadLog();
  }, [FromDate, ToDate, TransactionMode, page, sizePerPage]);

  const dateFormater = (cell, row) => {
    return moment(cell ? cell : new Date()).format("lll");
  };

  const transactionModeFormatter = (cell, row) => {
    if (row.transactionMode == "Debit") {
      return (
        <div>
          <span className="text-danger">Debit</span>{" "}
          <img
            src="/assets/images/debit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    } else {
      return (
        <div>
          <span className="text-success">Credit</span>
          <img
            src="/assets/images/credit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    }
  };
  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.transactionAmount} </span>;
  };
  const leadgerBalanceFormatter = (cell, row) => {
    return <span> ₹ {row.leadgerBalance} </span>;
  };
  const openingFormatter = (cell, row) => {
    return <span> ₹ {row.opening} </span>;
  };
  const closingFormatter = (cell, row) => {
    return <span> ₹ {row.closing} </span>;
  };
  const creditFormatter = (cell, row) => {
    if (row.creditBalance == 0 || row.creditBalance == null) {
      return <span> ₹ 0 </span>;
    } else {
      return <span> ₹ {row.creditBalance} </span>;
    }
  };

  const refreshFilter = async (e) => {
    setData([]);
    setPage(1);
    setSizePerPage(10);
    setDataCount(0);
    setLoading(true);
    setFromDate("");
    setToDate("");
    setTransactionMode("");
    setTimeout(async () => {
      await resetTableHandler();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );
  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{cell}</div>}
      >
        <a href="#">{cell?.substring(0, 10)}...</a>
      </Tooltip>
    );
  };

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const columns = [
    {
      dataField: "sln",
      text: "Txn Id",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "80px" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "150px" };
      },
    },
    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionDate",
      text: "Txn Date",
      headerStyle: (colum, colIndex) => {
        return { width: "220px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "ladgerDate",
      text: "Approval Date",
      headerStyle: (colum, colIndex) => {
        return { width: "220px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "refNo",
      text: "Ref No",
      headerStyle: (colum, colIndex) => {
        return { width: "220px", textAlign: "center" };
      },
    },
    {
      dataField: "correlationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionType",
      text: "Txn Type",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Txn Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: transactionAmountFormatter,
    },
    {
      dataField: "transactionMode",
      text: "Txn Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: transactionModeFormatter,
    },
    {
      dataField: "opening",
      text: "Opening",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: openingFormatter,
    },
    {
      dataField: "closing",
      text: "Closing",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: closingFormatter,
    },
    {
      dataField: "creditBalance",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: creditFormatter,
    },
    {
      dataField: "leadgerBalance",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: leadgerBalanceFormatter,
    },

    {
      dataField: "narration",
      text: "Narration",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
    {
      dataField: "userRemark",
      text: "Remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadLog = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
    });

    const response = await getTransactionLogAll(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const resetTableHandler = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    const response = await getTransactionLogAll(query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setTimeout(() => {
      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    }, 10);
  };

  const exportLog = async () => {
    const query = queryString.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
    });

    const response = await exportLedger(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_transactionLog.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await exportLog();
    }, 10);
  };

  return (
    <>
      <Helmet>
        <title>Transaction History</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Transaction History" }]}
      ></Breadcrumb>
      <div className="card card-body text-left " id="transactionHistory">
        <div className="card-body mr-2">
          <div className=" mx-auto">
            <div className="bookingList-header">
              <div className="row">
                <div className="col-12 col-md-3">
                  <div className="input-group mb-3">
                    <input
                      type="date"
                      className="form-control"
                      value={FromDate}
                      data-date=""
                      name="FromDate"
                      onChange={handleSearchChanges}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="input-group mb-3">
                    <input
                      type="date"
                      className="form-control"
                      data-date=""
                      //data-date-format="YYYY-MM-DD"
                      value={ToDate}
                      name="ToDate"
                      onChange={handleSearchChanges}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={TransactionMode}
                      name="TransactionMode"
                      onChange={handleSearchChanges}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-3 d-flex justify-content-center mb-3">
                  <button
                    className="btn btn-primary me-2"
                    onClick={refreshFilter}
                  >
                    Rfresh
                  </button>
                  <Button
                    variant="outline-primary"
                    className="ms-2"
                    onClick={handleExport}
                    disabled={!dataCount}
                  >
                    Export
                    <AiFillFileExcel className="" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <HandyScroll>
            <div
              class="spacious-container"
              data-handy-scroll
              style={{ overflow: "auto" }}
            >
              <BootstrapTable
                hover
                remote
                keyField="sln"
                data={data}
                columns={columns}
                pagination={
                  dataCount > 0 && paginationFactory(paginationOptions)
                }
                onTableChange={handleTableChange}
                noDataIndication={() => <NoDataIndication />}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                rowStyle={rowStyle}
              />
            </div>
          </HandyScroll>
        </div>
      </div>
    </>
  );
};

export default TransactionHistory;
